import { Shirt, ShoppingBag, Frame, Award } from 'lucide-react';

const ProductCatalog = () => {
  const categories = [
    {
      id: 'tshirts',
      name: 'Custom T-Shirts',
      description: 'Premium cotton tees with vibrant prints',
      icon: Shirt,
      image: 'https://images.pexels.com/photos/4066293/pexels-photo-4066293.jpeg?auto=compress&cs=tinysrgb&w=800',
    },
    {
      id: 'tote-bags',
      name: 'Tote Bags',
      description: 'Custom canvas & eco-friendly bags',
      icon: ShoppingBag,
      image: 'https://images.pexels.com/photos/6787035/pexels-photo-6787035.jpeg?auto=compress&cs=tinysrgb&w=800',
    },
    {
      id: 'posters',
      name: 'Posters & Wall Art',
      description: 'High-quality prints for any space',
      icon: Frame,
      image: 'https://images.unsplash.com/photo-1639749601642-8d30474f249f?w=800&fit=crop',
    },
    {
      id: 'hats',
      name: 'Hats & Caps',
      description: 'Custom embroidered headwear',
      icon: Award,
      image: 'https://images.unsplash.com/photo-1622445275576-721325763afe?w=800&fit=crop',
    },
  ];

  return (
    <section
      id="products"
      data-testid="products-section"
      className="py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2
            data-testid="products-heading"
            className="font-heading text-3xl md:text-4xl lg:text-5xl tracking-tight font-bold text-coastal-navy mb-6"
          >
            Beautiful bestselling blanks,{' '}
            <span className="text-coastal-orange">ready for your vision</span>
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed">
            Our premium quality products are your canvas. Create spectacular
            designs with large print areas and superior materials.
          </p>
        </div>

        {/* Products Grid - 2x2 */}
        <div
          data-testid="products-grid"
          className="grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8"
        >
          {categories.map((category) => {
            const Icon = category.icon;

            return (
              <div
                key={category.id}
                data-testid={`product-${category.id}`}
                className="group relative bg-coastal-offwhite border border-gray-200 rounded-3xl overflow-hidden transition-all duration-300 hover:shadow-2xl hover:-translate-y-2 cursor-pointer"
              >
                {/* Image */}
                <div className="relative h-72 md:h-80 overflow-hidden">
                  <img
                    src={category.image}
                    alt={category.name}
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  {/* Overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                </div>

                {/* Content */}
                <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="w-10 h-10 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center">
                      <Icon className="w-5 h-5 text-white" />
                    </div>
                    <h3 className="font-heading font-bold text-white text-xl md:text-2xl">
                      {category.name}
                    </h3>
                  </div>
                  <p className="text-white/80 text-base">{category.description}</p>
                </div>

                {/* Hover Effect */}
                <div className="absolute inset-0 bg-coastal-orange/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
            );
          })}
        </div>

        {/* Browse All CTA */}
        <div className="text-center mt-12">
          <a
            href="#contact"
            data-testid="browse-all-cta"
            className="inline-flex items-center gap-2 text-coastal-navy font-semibold hover:text-coastal-orange transition-colors"
          >
            Request Custom Products
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 8l4 4m0 0l-4 4m4-4H3"
              />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ProductCatalog;
